import React, { useId } from "react";
import styles from "./style";

const ColorRow = ({
  colors,
  selectedColorHex,
  onSelect,
  componentName,
  className,
  ariaLabel = "Color",
}) => {
  const groupName = useId();

  if (!Array.isArray(colors) || colors.length === 0) {
    return null;
  }

  const handleChange = (color) => {
    onSelect(color.colorHex);
    import("@gc-npm/utils.metrics.send-ga-component-event")
      .then(({ default: sendGaComponentEvent }) => sendGaComponentEvent({
        componentContent: color.colorName || color.colorHex,
        componentName,
        eventType: "click",
      }))
      .catch(() => {});
  };

  return (
    <ul
      className={`color-row${className ? ` ${className}` : ""}`}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {colors.map((color) => (
        <li
          key={`color-row-${color.colorHex}`}
          role="none"
        >
          <label className="color-row--option">
            <input
              className="color-row--input"
              type="radio"
              name={`color-${groupName}`}
              value={color.colorHex}
              checked={color.colorHex === selectedColorHex}
              onChange={() => handleChange(color)}
              aria-label={color.colorName || color.colorHex || "Color"}
            />
            <span
              aria-hidden="true"
              className={`color-row--circle${
                color.colorHex === selectedColorHex
                  ? " color-row--circle--selected"
                  : ""
              }`}
              style={{ backgroundColor: color.colorHex }}
            />
          </label>
        </li>
      ))}
      <style jsx>{styles}</style>
    </ul>
  );
};

export default ColorRow;
